import Highcharts from "highcharts";
import dayjs from "dayjs";
import { fetchFeed, toRows, pick, num } from "./feeds.js";

// Historical premium / discount: daily line graph plus the per-quarter day counts
// required under Rule 6c-11. Accepts the Ultimus shape (one record per quarter with
// a premiumDiscounts array) or a flat list of daily points.
export async function getPremiumDiscount(fundID) {
    const data = await fetchFeed("get_premium_discount", fundID);
    const points = toPoints(data);
    if (!points.length) return;

    points.sort((a, b) => a.date.valueOf() - b.date.valueOf());
    renderTable(points);
    renderChart(points);
}

function toPoints(data) {
    const rows = toRows(data);
    const daily = [];
    rows.forEach((r) => {
        const nested = pick(r, ["premiumDiscounts", "days", "points"]);
        (Array.isArray(nested) ? nested : [r]).forEach((d) => {
            const date = dayjs(pick(d, ["asOfDate", "date", "performDate", "navDate"]));
            if (!date.isValid()) return;
            const nav = num(pick(d, ["nav", "naV_NoLoad", "netAssetValue"]));
            const market = num(pick(d, ["marketPrice", "closingPrice", "closingMarketPrice"]));
            let value = num(pick(d, ["premiumDiscountPercent", "premiumDiscountPercentage", "premiumDiscountPct"]));
            if (value == null && market != null && nav) value = ((market - nav) / nav) * 100;
            if (value == null) {
                const raw = num(pick(d, ["premiumDiscount"]));
                if (raw != null) value = nav ? (raw / nav) * 100 : raw;
            }
            if (value == null) return;
            daily.push({ date: date, value: Math.round(value * 100) / 100 });
        });
    });
    return daily;
}

function renderTable(points) {
    const quarters = {};
    points.forEach((p) => {
        const q = Math.floor(p.date.month() / 3) + 1;
        const key = p.date.year() + "-" + q;
        const bucket = (quarters[key] = quarters[key] || { label: "Q" + q + " " + p.date.year(), key: key, prem: 0, zero: 0, disc: 0, max: null, min: null });
        if (p.value > 0) bucket.prem++;
        else if (p.value < 0) bucket.disc++;
        else bucket.zero++;
        bucket.max = bucket.max == null ? p.value : Math.max(bucket.max, p.value);
        bucket.min = bucket.min == null ? p.value : Math.min(bucket.min, p.value);
    });

    const rows = Object.keys(quarters)
        .sort()
        .reverse()
        .map((k) => quarters[k])
        .map(
            (b) =>
                "<tr><td class=\"rowlabel\">" + b.label + "</td>" +
                "<td class=\"num\">" + b.prem + "</td>" +
                "<td class=\"num\">" + b.zero + "</td>" +
                "<td class=\"num\">" + b.disc + "</td>" +
                "<td class=\"num\">" + (b.max > 0 ? "+" + b.max.toFixed(2) + "%" : "--") + "</td>" +
                "<td class=\"num\">" + (b.min < 0 ? "−" + Math.abs(b.min).toFixed(2) + "%" : "--") + "</td></tr>"
        )
        .join("");
    $("#premDiscRows").html(rows);
}

function renderChart(points) {
    const series = points.map((p) => [Date.UTC(p.date.year(), p.date.month(), p.date.date()), p.value]);

    Highcharts.chart("premiumLineGraph", {
        title: { text: null },
        subtitle: { text: null },
        chart: { plotBackgroundColor: null, backgroundColor: null, style: { fontFamily: "ingra, sans-serif" } },
        credits: { enabled: false },
        accessibility: { enabled: false },
        yAxis: {
            gridLineColor: "#e3e7e2",
            title: { text: null },
            plotLines: [{ color: "#e3e7e2", width: 3, value: 0 }],
            labels: { style: { fontSize: "12px", color: "#0a0a0a" }, format: "{value:.2f}%" },
        },
        xAxis: {
            type: "datetime",
            dateTimeLabelFormats: { day: "%m/%d", week: "%m/%d", month: "%m/%Y" },
            labels: { style: { fontSize: "12px" } },
        },
        legend: { layout: "horizontal", align: "center", verticalAlign: "bottom", symbolWidth: 35, itemStyle: { fontSize: "12px" } },
        plotOptions: { series: { color: "#003237", label: { connectorAllowed: false }, marker: { enabled: false } } },
        tooltip: { valueSuffix: "%", valueDecimals: 2, xDateFormat: "%B %e, %Y", shared: true },
        series: [{ name: "Premium/Discount", type: "line", lineWidth: 4, data: series }],
        responsive: { rules: [{ condition: { maxWidth: 500 }, chartOptions: { legend: { layout: "horizontal", align: "center", verticalAlign: "bottom" } } }] },
    });
}
